import * as types from '../actions/plugAction';

const initialState = {
  restaurantUuid: 'select',
  isLoading: false,
  zone: 'select',
  mode: 'select',
  monitors: 0,
  layoutType: 'horizontal',
  activeStreamId: '',
  restart: false,
  startedMode: '',
  streamsList: [],
  hasWebRTCError: false,
  tries: 0,
};

const plugReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PLUG_ZONE_STREAMS_SUCCESS:
      return {
        ...state,
        streamsList: action.payload.results.map(({ streamName }, index) => ({
          key: Date.now() + index,
          streamName: streamName,
          modalOpened: false,
          metaLoaded: false,
        })),
        monitors: action.payload.results.length,
        zone: action.payload.zone,
      };
    case types.CHANGE_PLUG_PLAY_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case types.CHANGE_PLUG_PLAY_STREAM_VALUE:
      return {
        ...state,
        streamsList: state.streamsList.map((stream) =>
          stream.key === action.payload.key
            ? {
                ...stream,
                [action.payload.name]: action.payload.value,
              }
            : stream
        ),
      };
    case types.SWAP_PLUG_PLAY_STREAMS: {
      const firstStream = state.streamsList[action.payload.index1];
      const secondStream = state.streamsList[action.payload.index2];
      const updatedStreamsList = [...state.streamsList];
      updatedStreamsList[action.payload.index1] = secondStream;
      updatedStreamsList[action.payload.index2] = firstStream;
      return {
        ...state,
        streamsList: updatedStreamsList,
      };
    }
    case types.RESET_PLUG_PLAY_STORE:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default plugReducer;
